"use client";

import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import {
  BaseTooltip,
  BaseTooltipPopup,
  type BaseTooltipPopupProps,
  BaseTooltipTrigger,
} from "./tooltip";
import type { ToolTipParts } from ".";

// TODO: remove all the generic colors, that was for testing since our tenant hexes are not setup yet
const conEdisonTooltipPopupVariants = cva({
  base: "rounded-none bg-tenant-con-edison-primary-white bg-red-500",
  variants: {
    tenantVariant: {
      "oru-reco": null,
    },
  },
  compoundVariants: [
    {
      tenantVariant: ["oru-reco"],
      className: "bg-tenant-oru-primary-white bg-green-500",
    },
  ],
});

const conEdisonTooltipArrowVariants = cva({
  base: "-mt-[1px] fill-popover fill-tenant-con-edison-primary-white bg-blue-500",
  variants: {
    tenantVariant: {
      "oru-reco": null,
    },
  },
  compoundVariants: [
    {
      tenantVariant: ["oru-reco"],
      className: "fill-tenant-oru-primary-white bg-orange-500",
    },
  ],
});

export default function ConEdisonTooltipPopup({
  className,
  tenant,
  withArrow = true,
  children,
  ...props
}: BaseTooltipPopupProps) {
  const tenantVariant =
    tenant?.variantId === "oru-reco" ? "oru-reco" : undefined;

  return (
    <BaseTooltipPopup
      {...props}
      className={cn(
        conEdisonTooltipPopupVariants({
          ...(tenantVariant && { tenantVariant }),
          className,
        }),
      )}
    >
      {/* TODO: figure out why this isnt working, no arrow is showing */}
      {withArrow && (
        <TooltipPrimitive.Arrow
          className={cn(
            conEdisonTooltipArrowVariants({
              ...(tenantVariant && { tenantVariant }),
            }),
            className,
          )}
        />
      )}
      {children}
    </BaseTooltipPopup>
  );
}

export const conEdisonTooltipKit: ToolTipParts = {
  Provider: BaseTooltip,
  Root: BaseTooltip,
  Trigger: BaseTooltipTrigger,
  Popup: ConEdisonTooltipPopup,
};
